function isStaleReview(review) {
  const stale = String(review?.staleState || "").toLowerCase();
  return Boolean(review) && stale && stale !== "fresh";
}

export function deliveredWorkFromReview(review, repo = {}, plan = null) {
  const persisted = plan?.deliveredWork || {};
  const source = review?.reviewSource || {};
  const pullNumber =
    persisted.pullNumber || source.pullRequestNumber || source.pullNumber || null;
  const branchName = persisted.headRef || source.branchName || source.headRef || null;
  const known = Boolean(pullNumber || branchName || persisted.originalInput || persisted.canonicalUrl);
  const repoLabel = repo?.name ? String(repo.name) : "Repository";
  const owner = repo?.owner || source.owner;
  const name = repo?.name || source.repo;
  let url = persisted.canonicalUrl || null;
  if (!url && pullNumber && owner && name) {
    url = `https://github.com/${owner}/${name}/pull/${pullNumber}`;
  } else if (!url && branchName && owner && name) {
    url = `https://github.com/${owner}/${name}/tree/${branchName}`;
  }
  return {
    known,
    pullNumber,
    branchName,
    label:
      persisted.friendlyLabel ||
      (pullNumber ? `${repoLabel} PR #${pullNumber}` : branchName || null),
    url,
    originalInput: persisted.originalInput || url,
    comparison:
      source.baseRef && branchName ? `${source.baseRef} → ${branchName}` : null,
    filesChanged: review?.branchEvidence?.totalChangedFiles ?? null,
    lastChecked: review?.completedAt || review?.updatedAt || null,
    stale: isStaleReview(review),
    status: !review
      ? "missing"
      : review.status === "pending" || review.status === "running"
        ? "running"
        : isStaleReview(review)
          ? "changed"
          : review.status === "failed"
            ? "failed"
            : review.status === "completed"
              ? "complete"
              : "current",
    headSha: source.headCommitSha || source.headSha || null,
    baseSha: source.baseCommitSha || source.baseSha || null,
  };
}

export function founderSourceAction(work) {
  if (!work || !work.known || work.status === "missing") {
    return { id: "connect_delivered_work", label: "Connect delivered work", section: "delivery" };
  }
  if (work.status === "changed") {
    return { id: "review_latest_version", label: "Review latest version", section: "review" };
  }
  if (work.status === "running") {
    return { id: "view_review", label: "View review", section: "review" };
  }
  if (work.status === "complete") {
    return { id: "view_review", label: "View review", section: "review" };
  }
  return { id: "review_this_work", label: "Review this work", section: "review" };
}

export function formatCheckedDate(value) {
  if (!value) return null;
  try {
    return new Date(value).toLocaleDateString(undefined, {
      month: "long",
      day: "numeric",
    });
  } catch {
    return null;
  }
}
